var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"landing-box"},[_vm._v(" "+_vm._s(_vm.msg)+" ")]),_c('ConfirmDialog',{ref:"confirmDialog"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }